
export const ON_DEVICE_CHANGED = 'ON_DEVICE_CHANGED';


export const onDeviceChanged = (device) => {
    console.log('onDeviceChanged data --> ', device);
    return dispatch => {
        dispatch({ type: ON_DEVICE_CHANGED, payload: { data: device } });
    }
}

const ACTION_HANDLERS = {
    [ON_DEVICE_CHANGED] : (state, action)=>{
        let data = action.payload.data;
        return {
            ...state,
            current : data,
        }
    }
};

const initialState = {
    current : 'pc', // 'pc' or 'mobile'
};

export default function noticeReducer(state = initialState, action) {
    const handler = ACTION_HANDLERS[action.type];
    return handler ? handler(state, action) : state;
};